import { toIsoTimestamp } from './time';
import { parseReactionCounts } from './reactionCounts';

function normalizeConversationId(rawConversationId) {
  if (typeof rawConversationId !== 'string') return null;
  const trimmed = rawConversationId.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('CONV#')) {
    return trimmed.slice(5) || null;
  }
  return trimmed;
}

export function reconcileMessagesWithServer(serverMessages, conversationId) {
  if (!Array.isArray(serverMessages)) return [];
  const normalizedCurrentConversationId = normalizeConversationId(conversationId);

  return serverMessages
    .filter((msg) => {
      if (!msg) return false;
      const normalizedConversationId = normalizeConversationId(msg.conversationId);
      if (!normalizedConversationId) return true;
      if (!normalizedCurrentConversationId) return true;
      return normalizedConversationId === normalizedCurrentConversationId;
    })
    .map((msg) => ({
      ...msg,
      conversationId: normalizeConversationId(msg.conversationId) || normalizedCurrentConversationId || conversationId,
      senderId: msg.senderId || msg.senderUsername || 'unknown',
      createdAt: toIsoTimestamp(msg.createdAt || msg.timestamp),
      timestamp: toIsoTimestamp(msg.timestamp || msg.createdAt),
      threadParentId: msg.threadParentId || null,
      threadReplyCount: msg.threadReplyCount || 0,
      // AppSync types reactionCounts as AWSJSON, which lands at the UI as
      // either a string or an object depending on the path. Normalize
      // here so downstream code can always treat it as an object or null.
      reactionCounts: parseReactionCounts(msg.reactionCounts),
      widgetType: msg.widgetType || null,
      widgetData: msg.widgetData || null,
      widgetActionUserId: msg.widgetActionUserId || null
    }));
}
